"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.propTypes = exports.defaultProps = void 0;
var prop_types_1 = require("prop-types");
var warning_1 = __importDefault(require("warning"));
function deprecated(propType, defaultVal, alternative) {
    // the rest at the end is need to silence props warning => https://reactjs.org/warnings/dont-call-proptypes.html
    return function (props, propName, componentName) {
        var rest = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            rest[_i - 3] = arguments[_i];
        }
        if (props[propName] !== null && props[propName] !== undefined && props[propName] !== defaultVal) {
            var message = "\"".concat(propName, "\" prop of \"").concat(componentName, "\" has been deprecated. Please use \"").concat(alternative, "\" instead.");
            var testing = process && process.env ? process.env.JEST_WORKER_ID !== undefined : false;
            if (!testing) {
                (0, warning_1.default)(false, message);
            }
        }
        // @ts-ignore
        return propType.apply(void 0, __spreadArray([props, propName, componentName], rest, false));
    };
}
exports.defaultProps = {
    __forwarededRef: { current: null },
    // RENDER
    list: [],
    renderItem: null,
    limit: 0,
    renderWhenEmpty: null,
    reversed: false,
    renderOnScroll: false,
    wrapperHtmlTag: '',
    // DISPLAY
    display: {
        grid: false,
        gridGap: '',
        gridMinColumnWidth: '',
        row: false,
        rowGap: ''
    },
    displayGrid: false,
    displayRow: false,
    gridGap: '',
    rowGap: '',
    minColumnWidth: '',
    // FILTER
    filterBy: '',
    // GROUPS
    group: {
        by: '',
        limit: 0,
        of: 0,
        reversed: false,
        separator: null,
        separatorAtTheBottom: false,
        sortBy: '',
        sortCaseInsensitive: false,
        sortDescending: false
    },
    groupBy: '',
    groupOf: 0,
    groupReversed: false,
    groupSeparator: null,
    groupSeparatorAtTheBottom: false,
    groupSorted: false,
    groupSortedBy: '',
    groupSortedDescending: false,
    groupSortedCaseInsensitive: false,
    showGroupSeparatorAtTheBottom: false,
    // PAGINATION
    pagination: {
        hasMore: false,
        loadMore: null,
        loadingIndicator: null,
        loadingIndicatorPosition: ''
    },
    hasMoreItems: false,
    loadMoreItems: null,
    paginationLoadingIndicator: null,
    paginationLoadingIndicatorPosition: '',
    // SCROLL TO TOP
    scrollToTop: {
        button: null,
        offset: 50,
        padding: 20,
        position: 'bottom right'
    },
    scrollToTopButton: null,
    scrollToTopOffset: 50,
    scrollToTopPadding: 20,
    scrollToTopPosition: 'bottom right',
    // SEARCH
    search: {
        by: '',
        caseInsensitive: false,
        everyWord: false,
        onEveryWord: false,
        minCharactersCount: 0,
        term: ''
    },
    searchBy: '',
    searchCaseInsensitive: false,
    searchOnEveryWord: false,
    searchTerm: '',
    searchMinCharactersCount: 0,
    searchableMinCharactersCount: 0,
    // SORT
    sort: {
        by: '',
        caseInsensitive: false,
        descending: false,
        groupBy: '',
        groupCaseInsensitive: false,
        groupDescending: false // deprecated
    },
    sortBy: '',
    sortCaseInsensitive: false,
    sortDesc: false,
    sortDescending: false,
    sortGroupBy: '',
    sortGroupDesc: false,
    sortGroupCaseInsensitive: false // deprecated
};
exports.propTypes = {
    __forwarededRef: prop_types_1.object,
    // RENDER
    list: (0, prop_types_1.oneOfType)([prop_types_1.array, prop_types_1.object]).isRequired,
    renderItem: (0, prop_types_1.oneOfType)([prop_types_1.func, prop_types_1.node]).isRequired,
    limit: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    renderWhenEmpty: prop_types_1.func,
    reversed: prop_types_1.bool,
    renderOnScroll: prop_types_1.bool,
    wrapperHtmlTag: prop_types_1.string,
    // DISPLAY
    display: (0, prop_types_1.shape)({
        grid: prop_types_1.bool,
        gridColumnWidth: prop_types_1.string,
        gridGap: prop_types_1.string,
        row: prop_types_1.bool,
        rowGap: prop_types_1.string
    }),
    displayGrid: prop_types_1.bool,
    displayRow: prop_types_1.bool,
    gridGap: prop_types_1.string,
    rowGap: prop_types_1.string,
    minColumnWidth: prop_types_1.string,
    // FILTER
    filterBy: (0, prop_types_1.oneOfType)([prop_types_1.func, prop_types_1.string]),
    // GROUPS
    group: (0, prop_types_1.shape)({
        by: (0, prop_types_1.oneOfType)([prop_types_1.func, prop_types_1.string]),
        limit: deprecated(prop_types_1.number, (_a = exports.defaultProps.group) === null || _a === void 0 ? void 0 : _a.limit, 'group.of'),
        of: prop_types_1.number,
        reversed: prop_types_1.bool,
        separator: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.func, prop_types_1.element]),
        separatorAtTheBottom: prop_types_1.bool,
        sortedBy: (0, prop_types_1.oneOfType)([
            prop_types_1.string,
            (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool, descending: prop_types_1.bool })]))
        ]),
        sortBy: deprecated((0, prop_types_1.oneOfType)([
            prop_types_1.string,
            (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool, descending: prop_types_1.bool })]))
        ]), (_b = exports.defaultProps === null || exports.defaultProps === void 0 ? void 0 : exports.defaultProps.group) === null || _b === void 0 ? void 0 : _b.sortBy, 'sortedBy'),
        sortedCaseInsensitive: prop_types_1.bool,
        sortCaseInsensitive: deprecated(prop_types_1.bool, (_c = exports.defaultProps.group) === null || _c === void 0 ? void 0 : _c.sortCaseInsensitive, 'sortedCaseInsensitive'),
        sortedDescending: prop_types_1.bool,
        sortDescending: deprecated(prop_types_1.bool, (_d = exports.defaultProps.group) === null || _d === void 0 ? void 0 : _d.sortDescending, 'sortedDescending') // deprecated
    }),
    groupBy: (0, prop_types_1.oneOfType)([prop_types_1.func, prop_types_1.string]),
    groupOf: prop_types_1.number,
    groupReversed: prop_types_1.bool,
    groupSeparator: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.func, prop_types_1.element]),
    groupSeparatorAtTheBottom: prop_types_1.bool,
    showGroupSeparatorAtTheBottom: deprecated(prop_types_1.bool, exports.defaultProps.showGroupSeparatorAtTheBottom, 'groupSeparatorAtTheBottom'),
    groupSorted: prop_types_1.bool,
    groupSortedBy: (0, prop_types_1.oneOfType)([
        prop_types_1.string,
        (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool, descending: prop_types_1.bool })]))
    ]),
    groupSortedDescending: prop_types_1.bool,
    groupSortedCaseInsensitive: prop_types_1.bool,
    // PAGINATION
    // PAGINATE
    pagination: (0, prop_types_1.shape)({
        hasMore: prop_types_1.bool,
        loadMore: prop_types_1.func,
        loadingIndicator: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.func, prop_types_1.element]),
        loadingIndicatorPosition: prop_types_1.string
    }),
    hasMoreItems: prop_types_1.bool,
    loadMoreItems: prop_types_1.func,
    paginationLoadingIndicator: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.func, prop_types_1.element]),
    paginationLoadingIndicatorPosition: (0, prop_types_1.oneOf)(['left', 'center', 'right', '']),
    // SCROLL TO TOP
    scrollToTop: (0, prop_types_1.oneOfType)([
        prop_types_1.bool,
        (0, prop_types_1.shape)({
            button: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.element, prop_types_1.func]),
            offset: prop_types_1.number,
            padding: prop_types_1.number,
            position: (0, prop_types_1.oneOf)(['top right', 'top left', 'bottom right', 'bottom left'])
        })
    ]),
    scrollToTopButton: (0, prop_types_1.oneOfType)([prop_types_1.node, prop_types_1.element, prop_types_1.func]),
    scrollToTopOffset: prop_types_1.number,
    scrollToTopPadding: prop_types_1.number,
    scrollToTopPosition: (0, prop_types_1.oneOf)(['top right', 'top left', 'bottom right', 'bottom left']),
    // SEARCH
    search: (0, prop_types_1.shape)({
        by: (0, prop_types_1.oneOfType)([
            prop_types_1.func, prop_types_1.string,
            (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool })]))
        ]),
        caseInsensitive: prop_types_1.bool,
        everyWord: deprecated(prop_types_1.bool, (_e = exports.defaultProps.search) === null || _e === void 0 ? void 0 : _e.everyWord, 'search.onEveryWord'),
        onEveryWord: prop_types_1.bool,
        minCharactersCount: prop_types_1.number,
        term: prop_types_1.string
    }),
    searchBy: (0, prop_types_1.oneOfType)([
        prop_types_1.func, prop_types_1.string,
        (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool })]))
    ]),
    searchCaseInsensitive: prop_types_1.bool,
    searchOnEveryWord: prop_types_1.bool,
    searchableMinCharactersCount: deprecated(prop_types_1.number, exports.defaultProps.searchableMinCharactersCount, 'searchMinCharactersCount'),
    searchMinCharactersCount: prop_types_1.number,
    searchTerm: prop_types_1.string,
    // SORT
    sort: (0, prop_types_1.oneOfType)([
        prop_types_1.bool,
        (0, prop_types_1.shape)({
            by: (0, prop_types_1.oneOfType)([
                prop_types_1.string,
                (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool, descending: prop_types_1.bool })]))
            ]),
            caseInsensitive: prop_types_1.bool,
            descending: prop_types_1.bool,
            groupBy: prop_types_1.string,
            groupCaseInsensitive: prop_types_1.bool,
            groupDescending: prop_types_1.bool
        })
    ]),
    sortBy: (0, prop_types_1.oneOfType)([
        prop_types_1.string,
        (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool, descending: prop_types_1.bool })]))
    ]),
    sortCaseInsensitive: prop_types_1.bool,
    sortDesc: prop_types_1.bool,
    sortDescending: prop_types_1.bool,
    sortGroupBy: deprecated((0, prop_types_1.oneOfType)([
        prop_types_1.string,
        (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({ by: prop_types_1.string, caseInsensitive: prop_types_1.bool, descending: prop_types_1.bool })]))
    ]), exports.defaultProps.sortGroupBy, 'groupSortedBy'),
    sortGroupDesc: deprecated(prop_types_1.bool, exports.defaultProps.sortGroupDesc, 'groupSortedDescending'),
    sortGroupCaseInsensitive: deprecated(prop_types_1.bool, exports.defaultProps.sortGroupCaseInsensitive, 'Use "groupSeparatorAtTheBottom"') // deprecated
};
//# sourceMappingURL=flatListProps.js.map